// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d54dd79d","389":"2f5e063f","732":"decefdd1","977":"d1ffeb29"}[chunkId] + ".chunk.js";
};